import {
  PLAYER_API_SEARCH_FILTER,
  PLAYER_PERSONAL_SEARCH_FILTER,
  PLAYER_SEARCH_FILTER,
} from "@acme/constants";
import { createFileRoute } from "@tanstack/react-router";
import PlayerApiSearchFilterFormFields from "~/features/player-search-filters/_components/player-api-search-filter-form-fields.js";
import PlayerGlobalSearchFilterFormFields from "~/features/player-search-filters/_components/player-global-search-filter-form-fields.js";
import PlayerPersonalSearchFilterFormFields from "~/features/player-search-filters/_components/player-personal-search-filter-form-fields.js";
import ActiveSearchStatusToggle from "~/features/player-search-filters/_components/active-search-status-toggle.js";
import SearchFilterTabPage from "~/features/search-filters/_components/search-filter-tab-page.js";
import { normalizePlayerTag } from "~/features/search-filters/_utils/normalize-tag.js";

export const Route = createFileRoute("/_authed/my-players/$tag/clan-search/filters")({
  component: PlayerSearchFiltersPage,
});

function PlayerSearchFiltersPage() {
  const { tag } = Route.useParams();
  const playerTag = normalizePlayerTag(tag);
  const auth = { playerTag };

  return (
    <div className="space-y-6">
      <ActiveSearchStatusToggle playerTag={playerTag} />
      <SearchFilterTabPage
        auth={auth}
        modelX={PLAYER_SEARCH_FILTER}
        renderChildFormFields={{
          api: (form) => (
            <PlayerApiSearchFilterFormFields
              control={form.control}
              getValues={form.getValues}
              setValue={form.setValue}
            />
          ),
          personal: (form) => <PlayerPersonalSearchFilterFormFields control={form.control} />,
        }}
        renderFormFields={(form, helpers) => (
          <PlayerGlobalSearchFilterFormFields
            auth={auth}
            control={form.control}
            isDeletingChild={helpers?.isDeletingChild}
            onCreateApiFilter={
              helpers != null ? () => helpers.openChildCreate(PLAYER_API_SEARCH_FILTER) : undefined
            }
            onCreatePersonalFilter={
              helpers != null ? () => helpers.openChildCreate(PLAYER_PERSONAL_SEARCH_FILTER) : undefined
            }
            onDeleteApiFilter={
              helpers != null
                ? (filterId) => void helpers.deleteChild(PLAYER_API_SEARCH_FILTER, filterId)
                : undefined
            }
            onDeletePersonalFilter={
              helpers != null
                ? (filterId) => void helpers.deleteChild(PLAYER_PERSONAL_SEARCH_FILTER, filterId)
                : undefined
            }
            onEditApiFilter={
              helpers != null
                ? (filterId) => helpers.openChildEdit(PLAYER_API_SEARCH_FILTER, filterId)
                : undefined
            }
            onEditPersonalFilter={
              helpers != null
                ? (filterId) => helpers.openChildEdit(PLAYER_PERSONAL_SEARCH_FILTER, filterId)
                : undefined
            }
          />
        )}
      />
    </div>
  );
}
